import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import cards from '../settingsCards.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Props {
  icon: IconDefinition;
  title: string;
  /** A line under the title. `mono` draws it as an address. */
  subtitle: string;
  mono?: boolean;
  href: string;
}

/** A row that opens a page of music24.com in a new tab (design settings-redesign e1). */
const LegalLinkRowComponent: React.FC<Props> = ({ icon, title, subtitle, mono = false, href }) => (
  <a
    className={`${cards.row} ${cards.rowButton} text-reset text-decoration-none`}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <span className={cards.rowIcon}>
      <FontAwesomeIcon icon={icon} />
    </span>
    <span className={cards.rowText}>
      <span className={cards.rowTitle}>{title}</span>
      <span className={mono ? cards.rowMono : cards.rowSub}>{subtitle}</span>
    </span>
    <span className={cards.rowEnd}>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
    </span>
  </a>
);

export const LegalLinkRow = TypedMemo(LegalLinkRowComponent);
